import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, Button, Row, Col, Typography } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { login, registration } from '../http/userAPI';
import { observer } from 'mobx-react-lite';
import { Context } from '..';

const Auth = observer(() => {
    const { Text } = Typography;
    const { user } = useContext(Context);
    const location = useLocation();
    const isLogin = location.pathname === '/login';
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [errorEmail, setErrorEmail] = useState('');
    const [errorPassword, setErrorPassword] = useState('');
    const [generalError, setGeneralError] = useState('');

    const click = async () => {
        try {
            let data;
            if (isLogin) {
                data = await login(email, password);
            } else {
                data = await registration(email, password);
            }

            // Reset errors before checking
            setErrorEmail('');
            setErrorPassword('');
            setGeneralError('');

            if (data.errors) {
                // Loop through all errors returned
                data.errors.forEach(err => {
                    if (err.path === 'email') {
                        setErrorEmail(err.msg);
                    } else if (err.path === 'password') {
                        setErrorPassword(err.msg);
                    } else {
                        setGeneralError(err.msg);
                    }
                });
            } else {
                // Success: set user and navigate
                user.setUser(data);
                user.setIsAuth(true);

                if (user.user.role === 'ADMIN') {
                    user.setIsAdmin(true);
                    navigate('/admin');
                } else {
                    navigate('/');
                }
            }
        } catch (error) {
            // Handle backend ApiError or network issues
            if (error.response?.data?.message) {
                setGeneralError(error.response.data.message);
            } else {
                setGeneralError('An unexpected error occurred. Please try again.');
            }
        }
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                click();
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    return (
        <Row justify="center" style={{ marginTop: '1rem' }}>
            <Col xs={24} sm={16} md={12} lg={8}>
                <Form layout="vertical">
                    <Form.Item
                        label="Email"
                        validateStatus={errorEmail ? 'error' : ''}
                        help={errorEmail}
                    >
                        <Input
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        validateStatus={errorPassword ? 'error' : ''}
                        help={errorPassword}
                    >
                        <Input.Password
                            placeholder="Password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                    </Form.Item>

                    {generalError && (
                        <Text type="danger" style={{ marginBottom: '1rem', display: 'block' }}>
                            {generalError}
                        </Text>
                    )}

                    <Row justify="space-between" align="middle" style={{ marginBottom: '1rem' }}>
                        <Text>
                            {isLogin ? (
                                <>No Account? <Link to="/registration">Register</Link></>
                            ) : (
                                <>Have an Account? <Link to="/login">Login</Link></>
                            )}
                        </Text>
                    </Row>

                    <Form.Item>
                        <Button type="primary" onClick={click} block>
                            {isLogin ? 'Login' : 'Register'}
                        </Button>
                    </Form.Item>
                </Form>
            </Col>
        </Row>
    );
});

export default Auth;
